import { useEffect, useState } from 'react';
import { HoleParams, Area } from './types';

const getAreas = (selectors: HoleParams[]): Area[] => {
  const rects: Area[] = [];

  for (const item of selectors) {
    const domRect = document.querySelector(item.selector)?.getBoundingClientRect();

    if (!domRect) continue;

    let { x, y, width, height } = domRect;

    if (item.calculate) {
      const calculated = item.calculate(domRect);
      x = calculated.x;
      y = calculated.y;
      width = calculated.width;
      height = calculated.height;
    }

    if (item.height) height = item.height;

    if (item.gapFooter) {
      const footerHeight = 96;
      const maxBottom = document.body.clientHeight - footerHeight;
      const bottom = y + height;
      if (bottom > maxBottom) height -= bottom - maxBottom;
    }

    if (item.offset) {
      const [ox, oy, ow, oh] = item.offset;
      x += ox;
      y += oy;
      width += -ox + ow;
      height += -oy + oh;
    }

    rects.push({ x, y, width, height, noBorder: !!item.noBorder });
  }

  return rects;
};

export const useAreas = (selectors?: HoleParams[]) => {
  const [areas, setAreas] = useState<Area[]>([]);

  useEffect(() => {
    const update = () => setAreas(selectors ? getAreas(selectors) : []);
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [selectors]);

  return areas;
};
